<template>
  <div class="slider-body" :id="'slider-body-' + group.groupId">
    <div class="slider-content" :id="'slider-group-' + group.groupId">
      <button v-if="isScroll && showPrev && !mobileBigAndBelow" :id="'prev-btn-' + group.groupId" class="prev-btn casino-slider-btn" @click="slide('prev')">
        <v-icon>arrow_back_ios</v-icon>
      </button>
      <div :id="'item-list-' + group.groupId" class="item-list" :class="[{'has-scroll': isScroll}, {'double': group.groupName === 'Slots 2'}, section]" :data-item-list-id="group.groupId">
        <casino-slider-item class="item" :section="section" :class="[{'first-item': i === 0}, {'last-item': group.gameIds.length - 1 === i}, section]" v-for="(gameId, i) in group.gameIds" :key="gameId" :gameId="gameId" :iterator="i" ref="childRef" :data-gid="group.gameId" :gameInfoData="getGameInfoDataByGameId(gamesByGroup, gameId, group.groupName)" :isFavorite="isInFavorite(gameId)"></casino-slider-item>
      </div>
      <button v-if="isScroll && showNext && !mobileBigAndBelow" :id="'next-btn-' + group.groupId" class="next-btn casino-slider-btn" @click="slide('next')">
        <v-icon>arrow_forward_ios</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
import casinoSliderItem from '@/components/igaming/partials/casinoSliderItem.vue'
import Screen from '@/components/mixins/Screen'
import Casino from '@/components/mixins/Casino'

export default {
  name: 'casinoSlider',
  props: ['group', 'section', 'gamesByGroup'],
  mixins: [
    Screen,
    Casino
  ],
  components: {
    casinoSliderItem
  },
  data () {
    return {
      isScroll: true,
      showPrev: false,
      showNext: true
    }
  },
  computed: {},
  methods: {
    initLazyLoadingListener () {
      let listItemElement = document.querySelector('[data-item-list-id="' + this.group.groupId + '"]')
      listItemElement.addEventListener('scroll', this.lazyLoad)
      listItemElement.addEventListener('resize', this.lazyLoad)
      listItemElement.addEventListener('orientationChange', this.lazyLoad)
      this.lazyLoad()
    },
    lazyLoadFallback () {
      let self = this
      let listItemElement = document.querySelector('[data-item-list-id="' + self.group.groupId + '"]')
      let lazyLoadImages = listItemElement.querySelectorAll('img.lazy')
      let lazyLoadThrottleTimeout
      if (lazyLoadThrottleTimeout) {
        clearTimeout(lazyLoadThrottleTimeout)
      }

      lazyLoadThrottleTimeout = setTimeout(function () {
        let containerId = document.querySelector('[data-gid="' + self.group.groupId + '"]')
        let scrollId = document.querySelector('[data-item-list-id="' + self.group.groupId + '"]')
        let scroll = scrollId.scrollLeft
        lazyLoadImages.forEach(function (img) {
          if (img.offsetLeft < (containerId.clientWidth + scroll)) {
            img.src = img.dataset.src
            img.classList.remove('lazy')
          }
        })
        if (lazyLoadImages.length === 0) {
          listItemElement.removeEventListener('scroll', this.lazyLoad)
          listItemElement.removeEventListener('resize', this.lazyLoad)
          listItemElement.removeEventListener('orientationChange', this.lazyLoad)
        }
      }, 20)
    },
    lazyLoad () {
      let lazyLoadImages
      if ('IntersectionObserver' in window) {
        let listItemElement = document.querySelector('[data-item-list-id="' + this.group.groupId + '"]')
        lazyLoadImages = listItemElement.querySelectorAll('.game-image.lazy')
        let imageObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              let image = entry.target
              image.style.backgroundImage = 'url("' + image.dataset.src + '")'
              image.classList.remove('lazy')
              imageObserver.unobserve(image)
            }
          })
        }, { rootMargin: '100px' })
        // options { threshold: 1, rootMargin: 0px 200px 0px -50%', root: listItemElement }

        lazyLoadImages.forEach(function (image) {
          imageObserver.observe(image)
        })
      } else {
        this.lazyLoadFallback()
      }
    },
    resetAll () {
      this.isScroll = true
      this.showPrev = false
      this.showNext = true
    },
    slide (direction) {
      let container = document.getElementById('item-list-' + this.group.groupId)
      if (container) {
        if (direction === 'next') this.showPrev = true
        let dir = direction === 'prev' ? container.scrollLeft - 200 : container.scrollLeft + 200
        container.scrollTo({
          left: dir,
          top: 0,
          behavior: 'smooth'
        })
        const { isAtLeft, isAtRight } = this.checkHorizontalScroll(container, dir)
        setTimeout(() => {
          this.showPrev = !isAtLeft
          this.showNext = !isAtRight
        }, 0)
      }
    },
    isScrollElement () {
      let itemListElement = document.getElementById('item-list-' + this.group.groupId)
      let sliderBodyElement = document.getElementById('slider-body-' + this.group.groupId)
      let isScroll = itemListElement.scrollWidth > sliderBodyElement.clientWidth
      if (!isScroll) {
        this.isScroll = false
        this.$emit('showHideSeeAll', this.isScroll)
        return false
      }
      this.$emit('showHideSeeAll', this.isScroll)
    },
    checkHorizontalScroll (element, dir) {
      const isAtLeft = dir <= 0
      const isAtRight = dir + element.clientWidth >= element.scrollWidth
      return { isAtLeft, isAtRight }
    }
  },
  mounted () {
    this.initLazyLoadingListener()
    this.isScrollElement()
    if (this.section === 'FavoriteGames') {
      this.isScrollElement()
    }
  },
  beforeDestroy () {},
  destroy () {
    this.resetAll()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoSlider.vue